SNI.Application.addModule('jukebox', context => ({
  behaviors: ['load-more', 'lazy-load']
}));
